/**
 * PopupDetailContainer
 * --
 */
import React from 'react';
import PopupDetailPresenter from './PopupDetailPresenter';

const PopupDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PopupDetailPresenter />
    </>
  );
};

export default PopupDetailContainer;
